export const agents = [
    {
        id: "a1",
        name: "Alessandra Monroe",
        title: "Managing Principal",
        specialties: ["Luxury Residential", "Private Client"],
        bio: "Two decades of brokering trophy estates across the Strip, Summerlin, and The Ridges. Sotheby's-trained. Discreet, surgical, relentless.",
        image: "https://images.pexels.com/photos/7414956/pexels-photo-7414956.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700",
    },
    {
        id: "a2",
        name: "Julian Ashford",
        title: "Partner — Commercial Capital Markets",
        specialties: ["Office", "Hospitality", "Investment Sales"],
        bio: "Closed over $3.4B in commercial transactions. CCIM, MBA Wharton. Advises family offices and institutional capital on Las Vegas acquisitions.",
        image: "https://images.unsplash.com/photo-1621973133111-63649acea55a?auto=format&fit=crop&w=700&q=80",
    },
    {
        id: "a3",
        name: "Nadia Kovac",
        title: "Director — Luxury Residential",
        specialties: ["Penthouses", "New Development", "International Buyers"],
        bio: "Multilingual specialist for Monaco, Dubai, and Hong Kong buyers acquiring Las Vegas assets. Renowned for staged, cinematic listing campaigns.",
        image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=700&q=80",
    },
    {
        id: "a4",
        name: "Marcus DuBois",
        title: "Head of Industrial & Logistics",
        specialties: ["Industrial", "Land", "Portfolio"],
        bio: "Nevada native. Advises on last-mile logistics, data-center land, and adaptive-reuse infill. Formerly JLL Capital Markets.",
        image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?auto=format&fit=crop&w=700&q=80",
    },
    {
        id: "a5",
        name: "Serena Ito",
        title: "Director — Administration",
        specialties: ["Property Management", "Concierge", "Operations"],
        bio: "Oversees post-close administration for the firm's private-client portfolio. White-glove, by design.",
        image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?auto=format&fit=crop&w=700&q=80",
    },
    {
        id: "a6",
        name: "Ethan Calloway",
        title: "Advisor — Family Office Services",
        specialties: ["Acquisitions", "Discreet Off-Market"],
        bio: "Former investment banker curating silent-market opportunities for UHNW clients and single-family offices.",
        image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=700&q=80",
    },
];
